<div class="cl">
  <div class="cl-barra">
    <div class="cl-abas" role="tablist">
      <button type="button" role="tab" class="cl-aba" *ngFor="let aba of abas"
              [class.ativa]="abaAtual === aba.id" [attr.aria-selected]="abaAtual === aba.id"
              (click)="abaAtual = aba.id">
        {{ aba.rotulo }} <span class="cl-aba__total">{{ totalDaAba(aba.id) }}</span>
      </button>
    </div>

    <label class="cl-busca">
      <i class="fe-search"></i>
      <input type="search" placeholder="Buscar código ou descrição" [(ngModel)]="busca" aria-label="Buscar cupom">
    </label>
  </div>

  <div class="cl-lista" *ngIf="carregando && !cupons.length">
    <div class="cl-esqueleto" *ngFor="let i of [1, 2, 3, 4]"></div>
  </div>

  <div class="cl-vazio" *ngIf="!carregando && !cupons.length">
    <span class="cl-vazio__icone"><i class="fe-scissors"></i></span>
    <strong>Nenhum cupom ainda</strong>
    <p>Crie um código de desconto para divulgar no Instagram, no WhatsApp ou deixar à mostra na loja.</p>
    <button type="button" class="cl-btn cl-btn--primario" (click)="criarCupom()">
      <i class="fe-plus"></i> Criar primeiro cupom
    </button>
  </div>

  <p class="cl-vazio-aba" *ngIf="!carregando && cupons.length && !cuponsDaAba().length">
    {{ busca ? 'Nenhum cupom encontrado para "' + busca + '".' : textoAbaVazia() }}
  </p>

  <div class="cl-lista" *ngIf="cuponsDaAba().length">
    <article class="cl-card" *ngFor="let cupom of cuponsDaAba(); trackBy: porId"
             [ngClass]="['cl-card--' + statusDo(cupom).id, 'cl-cor--' + corDo(cupom)]" (click)="editarCupom(cupom)">
     <div class="cl-card__corpo">

      <div class="cl-canhoto">
        <!-- a fonte de ícones só pega com a classe fe- em primeiro no <i> ([class^="fe-"]) -->
        <span class="cl-canhoto__marca"><i [ngClass]="iconeDoTema(cupom)"></i></span>
        <span class="cl-canhoto__sobre">Desconto</span>
        <strong class="cl-canhoto__valor">{{ valorDoDesconto(cupom) }}</strong>
        <span class="cl-canhoto__rotulo">{{ rotuloDoDesconto(cupom) }}</span>
      </div>

      <div class="cl-card__principal">
        <div class="cl-card__topo">
          <button type="button" class="cl-codigo" (click)="$event.stopPropagation(); copyMessage(cupom.codigo)"
                  [title]="mensagemCopiada === cupom.codigo ? 'Código copiado' : 'Copiar código'">
            <span>{{ cupom.codigo }}</span>
            <i [ngClass]="mensagemCopiada === cupom.codigo ? 'fe-check' : 'fe-copy'"></i>
          </button>
          <span class="cl-status" [ngClass]="'cl-status--' + statusDo(cupom).id">
            <span class="cl-status__ponto"></span>{{ statusDo(cupom).rotulo }}
          </span>

          <label class="cl-switch" (click)="$event.stopPropagation()" [title]="cupom.ativo ? 'Pausar cupom' : 'Ativar cupom'">
            <input type="checkbox" role="switch" [checked]="cupom.ativo" [disabled]="cupom.processando"
                   (change)="alterneAtivo(cupom)" [attr.aria-label]="cupom.ativo ? 'Pausar cupom' : 'Ativar cupom'">
            <span class="cl-switch__trilho"></span>
          </label>
        </div>

        <div class="cl-card__nome" *ngIf="cupom.nome && cupom.nome !== cupom.codigo">{{ cupom.nome }}</div>

        <div class="cl-card__meta" *ngIf="cupom.valorMinimo > 0 || cupom.validade || cupom.horarios?.length">
          <span *ngIf="cupom.valorMinimo > 0"><i class="fe-shopping-cart"></i> Pedido mín. {{ cupom.valorMinimo | currency: 'BRL' }}</span>
          <span *ngIf="cupom.validade" [class.cl-vencido]="cupom.vencido">
            <i class="fe-calendar"></i> {{ cupom.vencido ? 'Venceu em' : 'Até' }} {{ cupom.validade | date: 'dd/MM/yyyy' }}
          </span>
          <span *ngIf="cupom.horarios?.length"><i class="fe-clock"></i> {{ textoDias(cupom) }}</span>
        </div>

        <div class="cl-regras" *ngIf="regrasDo(cupom).length || cupom.restrito || cupom.restritoContatoPerdido">
          <button type="button" class="cl-regra cl-regra--acao" *ngIf="cupom.restrito || cupom.restritoContatoPerdido"
                  (click)="$event.stopPropagation(); abraModalAssociarContatos(cupom)" title="Ver e escolher os contatos">
            <i class="fe-users"></i> {{ cupom.restritoContatoPerdido && !cupom.restrito ? 'Contatos perdidos' : 'Lista de contatos' }}
          </button>
          <span class="cl-regra" *ngFor="let regra of regrasDo(cupom)">{{ regra }}</span>
        </div>

        <div class="cl-card__rodape" (click)="$event.stopPropagation()">
          <div class="cl-link" *ngIf="cupom.link">
            <button type="button" (click)="copyMessage(cupom.link)">
              <i [ngClass]="mensagemCopiada === cupom.link ? 'fe-check' : 'fe-link'"></i>
              {{ mensagemCopiada === cupom.link ? 'Link copiado' : 'Copiar link' }}
            </button>
            <a [href]="cupom.link" target="_blank" rel="noopener"><i class="fe-external-link"></i> Abrir</a>
          </div>

          <div class="cl-card__acoes">
            <span class="cl-id">#{{ cupom.id }}</span>
            <button type="button" class="cl-icone-btn" (click)="editarCupom(cupom)" title="Editar" aria-label="Editar cupom">
              <i class="fe-edit-2"></i>
            </button>
            <button type="button" class="cl-icone-btn cl-icone-btn--perigo" (click)="abraDialogRemover(cupom)"
                    title="Remover" aria-label="Remover cupom">
              <i class="fe-trash-2"></i>
            </button>
          </div>
        </div>
      </div>
     </div>
    </article>
  </div>
</div>

<kendo-dialog class="cl-dialogo" *ngIf="modalDeletar" (close)="canceleRemocao()" [minWidth]="250" [width]="420">
  <div class="cl-remover">
    <span class="cl-remover__icone"><i class="fe-trash-2"></i></span>
    <h3>Remover cupom?</h3>
    <p>"<strong>{{ cupomApagar.codigo }}</strong>" deixa de funcionar e sai da lista. Para só suspender, use a chave do cupom.</p>
    <div class="cl-remover__acoes">
      <button type="button" class="cl-btn cl-btn--fantasma" (click)="canceleRemocao()">Cancelar</button>
      <button type="button" class="cl-btn cl-btn--perigo" (click)="confirmeRemocao()">Remover</button>
    </div>
  </div>
</kendo-dialog>
